<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Kernactiviteit bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeResultActivityDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditResultActivityForm" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="selectedResultActivityItem.name"
          required
          outlined
          hide-details
          :color="companyPrimaryColor"
          background-color="background"
          class="mt-4"
        ></v-text-field>

        <v-select
          :items="resultAreas"
          item-text="name"
          item-value="id"
          v-model="selectedResultActivityItem.area"
          label="Resultaatgebied"
          outlined
          hide-details
          :color="companyPrimaryColor"
          background-color="background"
          class="mt-4"
        >
        </v-select>

        <v-select
          :items="positions"
          background-color="background"
          item-text="name"
          item-value="id"
          v-model="selectedResultActivityItem.position"
          label="Functie"
          outlined
          hide-details
          :color="companyPrimaryColor"
          class="mt-4"
        >
        </v-select>

        <v-container
          grid-list-md
          fluid
          class="mt-3 ma-0 pa-2"
          :style="{ backgroundColor: $vuetify.theme.themes[theme].menuhover }"
        >
          <h2>Criteria</h2>
          <p>Voeg criteria toe voor het behalen van deze kerntaak.</p>
          <div
            v-if="
              selectedResultActivityItem.criteria &&
                selectedResultActivityItem.criteria.length > 0
            "
            style="padding: 0px; margin: 15px 0;"
            :style="{ backgroundColor: $vuetify.theme.themes[theme].menuhover }"
          >
            <draggable
              v-model="selectedResultActivityItem.criteria"
              @start="drag = true"
              @end="drag = false"
            >
              <div
                class="criterium"
                v-for="(criterium,
                index) in selectedResultActivityItem.criteria"
                :class="{ first: index == 0 }"
                :key="index"
              >
                <div class="handle">
                  <div class="icon">
                    <v-icon :color="$vuetify.theme.themes[theme].text"
                      >open_with</v-icon
                    >
                  </div>
                </div>

                <div class="description">
                  <b>{{ criterium.title }}</b
                  ><br />
                  {{ criterium.description }}
                </div>
                <div class="edit text-center" @click="editCriterium(index)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text"
                    >edit</v-icon
                  >
                </div>
                <div class="close text-center" @click="removeCriterium(index)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text"
                    >delete</v-icon
                  >
                </div>
              </div>
            </draggable>
          </div>
          <div
            v-else
            style="padding: 15px 5px; margin: 15px 0;"
            :style="{ backgroundColor: $vuetify.theme.themes[theme].menu }"
          >
            <p class="ma-0" style="text-align: center; font-style: italic;">
              Er zijn nog geen criteria toegevoegd.
            </p>
          </div>
          <div>
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Criterium</h3>
                <v-text-field
                  label="Titel"
                  v-model="resultCriterium.title"
                  prepend-inner-icon="check_circle"
                  required
                  dense
                  outlined
                  hide-details
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  height="45px"
                  class="ma-0 pa-0 pb-2"
                ></v-text-field>
                <v-textarea
                  label="Omschrijving"
                  v-model="resultCriterium.description"
                  prepend-inner-icon="format_align_left"
                  required
                  :rows="3"
                  outlined
                  hide-details
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  class="ma-0 pa-0"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  class="ma-0 pa-0"
                  block
                  dark
                  large
                  :color="companyPrimaryColor"
                  @click="addCriterium()"
                  >Toevoegen</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeResultActivityDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :loading="busy"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateResultActivity()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

    <!-- / Edit Criteria Dialog \-->
    <v-dialog v-model="selectedCriterium.dialog" max-width="600">
      <v-card :key="indexKey">
        <v-card-title
          class="pr-2"
          :style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2 class="white--text">Criteria wijzigen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="selectedCriterium.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert
          class="ma-0 pa-1"
          v-if="selectedCriterium.feedback"
          :value="true"
          type="warning"
          style="border-radius: 0px"
        >
          {{ selectedCriterium.feedback }}
        </v-alert>

        <v-divider></v-divider>

        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Titel"
            v-model="selectedCriterium.title"
            required
            hide-details
          ></v-text-field>

          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Omschrijving"
            v-model="selectedCriterium.description"
            required
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex
                xs12
                md6
                class="text-left"
                v-if="
                  $vuetify.breakpoint.name != 'sm' &&
                    $vuetify.breakpoint.name != 'xs'
                "
              >
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="selectedCriterium.dialog = false"
                >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  :dark="selectedCriteriumChanged"
                  :depressed="!selectedCriteriumChanged"
                  :disabled="!selectedCriteriumChanged"
                  rounded
                  :block="
                    $vuetify.breakpoint.name == 'sm' ||
                      $vuetify.breakpoint.name == 'xs'
                  "
                  :color="companySecondaryColor"
                  @click="updateSelectedCriterium()"
                >
                  Wijzingen opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ New Conversion Source Dialog / -->
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import Sortable from "sortablejs";
import draggable from "vuedraggable";

var uniqid = require("uniqid");

export default {
  name: "edit-result-activity-form",
  components: {
    draggable,
  },
  props: {
    activeCompData: Object,
    selectedResultActivityItem: Object,
    selectedResultActivityItemOriginal: Object,
    resultAreas: Array,
    positions: Array,
  },

  data() {
    return {
      feedback: null,
      resultCriterium: {
        title: null,
        description: null,
      },
      selectedCriterium: {
        dialog: false,
        index: null,
        title: null,
        description: null,
      },
      selectedCriteriumOriginal: null,
      busy: false,
      indexKey: 0,
    };
  },

  methods: {
    closeResultActivityDialog() {
      this.$emit("editResultActivityDialogChange", false);
      this.busy = false;
    },

    editCriterium(index) {
      this.selectedCriterium.index = index;
      this.selectedCriterium.title = this.selectedResultActivityItem.criteria[
        index
      ].title;
      this.selectedCriterium.description = this.selectedResultActivityItem.criteria[
        index
      ].description;
      this.selectedCriterium.feedback = null;
      this.selectedCriterium.dialog = true;
      this.selectedCriteriumOriginal = _.cloneDeep(this.selectedCriterium);
    },

    updateSelectedCriterium() {
      if (this.selectedCriterium.title) {
        this.selectedResultActivityItem.criteria[
          this.selectedCriterium.index
        ].title = this.selectedCriterium.title;
        this.selectedResultActivityItem.criteria[
          this.selectedCriterium.index
        ].description = this.selectedCriterium.description;
        this.selectedCriterium.dialog = false;
      } else {
        this.indexKey++;
        this.selectedCriterium.feedback = "Vul de titel in om op te slaan.";
      }
    },

    removeCriterium(index) {
      this.selectedResultActivityItem.criteria.splice(index, 1);
    },

    addCriterium() {
      if (this.resultCriterium) {
        let cirteria = _.cloneDeep(this.resultCriterium);
        cirteria.uniqid = uniqid();
        this.selectedResultActivityItem.criteria.push(cirteria);
        this.resultCriterium.title = null;
        this.resultCriterium.description = null;
      }
    },

    updateResultActivity() {
      if (
        this.selectedResultActivityItem.name &&
        this.selectedResultActivityItem.area
      ) {
        this.feedback = null;
        this.busy = true;
        db.collection("resultActivities")
          .doc(this.selectedResultActivityItem.id)
          .set(
            {
              name: this.selectedResultActivityItem.name,
              area: this.selectedResultActivityItem.area,
              position: this.selectedResultActivityItem.position,
              criteria: this.selectedResultActivityItem.criteria,
            },
            { merge: true },
          )
          .then(() => {
            this.busy = false;
            this.closeResultActivityDialog();
            this.$emit("updateData");
          })
          .catch((error) => {
            this.busy = false;
            console.error("Error updating result activity: ", error);
          });
      } else {
        this.feedback = "Vul alle velden in om de wijzigingen op te slaan";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    selectedCriteriumChanged() {
      if (
        _.isEqual(this.selectedCriterium, this.selectedCriteriumOriginal) ==
        false
      ) {
        return true;
      } else {
        return false;
      }
    },
    changed() {
      if (
        _.isEqual(
          this.selectedResultActivityItem,
          this.selectedResultActivityItemOriginal,
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
